import React from "react";
import BirthdayCard from "../../assets/pic/image1.webp";
import WeddingCard from "../../assets/pic/image2.webp";
import PartyCard from "../../assets/pic/image3.webp";
import { useNavigate } from "react-router-dom";
import { LayoutForLandingPage } from "./Home";
const PopularCategories = () => {
  const redirect = useNavigate();
  return (
    <div className="w-full flex justify-center items-center">
      <div className="bg-custom-gradient flex flex-col justify-center items-center pb-12 w-full">
        <h2 className="lg:text-[56px] text-[24px] font-semibold text-[#2F3649] mt-8 p-4 text-center">
          What Makes Us <span className="text-[#F66061]">Special ?</span>
        </h2>
        <LayoutForLandingPage>
          <div className="space-y-8 max-w-6xl flex flex-col items-center mt-4">
            {/* Section 1: Image on the left, Text on the right */}
            <div className="flex flex-col lg:flex-row lg:gap-[14rem] gap-5 items-center">
              <div className="bg-[#FFFFFF] p-[2px] rounded-lg w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-[450px] mb-4 lg:mb-0 shadow-lg">
                <img src={BirthdayCard} alt="Image 1" className="rounded-lg" />
              </div>
              <div className="text-center lg:text-left">
                <h2 className="lg:text-[3em] !text-[2.8em] text-[#2F3649] font-semibold leading-tight mb-4">
                  Personalized messages
                </h2>
                <p className="text-gray-600">
                  Struggling with what to write? Our AI message generator will
                  assist you in drafting thoughtful, custom messages based on
                  your recipient’s personality traits—so your card always feels
                  personal and meaningful.
                </p>
                <button
                  onClick={() => redirect("browse_cards/birthday-card")}
                  className="bg-[#F66061] hover:bg-primary-dark text-white px-10 py-3 rounded-md md:text-xl text-sm mt-4"
                >
                  Explore More Cards
                </button>
              </div>
            </div>

            {/* Section 2: Image on the right, Text on the left */}
            <div className="flex flex-col lg:flex-row-reverse lg:gap-[14rem] gap-5 items-center">
              <div className="bg-[#FFFFFF] p-[2px] rounded-lg w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-[450px] mb-4 lg:mb-0 shadow-lg">
                <img src={WeddingCard} alt="Image 2" className="rounded-lg" />
              </div>
              <div className="text-center lg:text-left">
                <h2 className="lg:text-[3em] !text-[2.8em] text-[#2F3649] font-bold leading-tight mb-4">
                  Never Miss an Important Date
                </h2>
                <p className="text-gray-600">
                  Easily schedule cards for birthdays, anniversaries, and other
                  special occasions. We’ll make sure you never miss another
                  special moment.
                </p>
                <button
                  onClick={() => redirect("/browse_cards/fathers-day")}
                  className="bg-[#F66061] hover:bg-primary-dark text-white px-10 py-3 rounded-md md:text-xl text-sm mt-4"
                >
                  Explore More Cards
                </button>
              </div>
            </div>

            {/* Section 3: Image on the left, Text on the right */}
            <div className="flex flex-col lg:flex-row lg:gap-[14rem] gap-5 items-center">
              <div className="bg-[#FFFFFF] p-[2px] rounded-lg w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-[450px] mb-4 lg:mb-0 shadow-lg">
                <img src={PartyCard} alt="Image 3" className="rounded-lg" />
              </div>
              <div className="text-center lg:text-left">
                <h2 className="lg:text-[3em] !text-[2.8em] text-[#2F3649] font-bold leading-tight mb-4">
                We Print it & Mail it
                  {/* It for You */}
                </h2>
                <p className="text-gray-600">
                  Once your card is ready, we take care of the rest. Your
                  greeting card is printed, sealed, and mailed directly to your
                  loved one—no trip to the post office needed.
                </p>
                <button
                  onClick={() => redirect("/browse_cards/mothers-day")}
                  className="bg-[#F66061] hover:bg-primary-dark text-white px-10 py-3 rounded-md md:text-xl text-sm mt-4"
                >
                  Explore More Cards
                </button>
              </div>
            </div>
          </div>
        </LayoutForLandingPage>
      </div>
    </div>
  );
};

export default PopularCategories;
